var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.475 20 0 15.525 0 10C0 4.475 4.475 0 10 0C15.525 0 20 4.475 20 10C20 15.525 15.525 20 10 20ZM15 6.25C14.65 6.25 14.3375 6.3875 14.1125 6.6125L8.75 11.9875L5.8875 9.1125C5.6625 8.8875 5.35 8.75 5 8.75C4.3125 8.75 3.75 9.3125 3.75 10C3.75 10.35 3.8875 10.6625 4.1125 10.8875L7.8625 14.6375C8.0875 14.8625 8.4 15 8.75 15C9.1 15 9.4125 14.8625 9.6375 14.6375L15.8875 8.3875C16.1125 8.1625 16.25 7.85 16.25 7.5C16.25 6.8125 15.6875 6.25 15 6.25Z",
    fill: "#2ED93F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/approved.8c467aedff8848fb91025848eefb2340.svg";
export { ForwardRef as ReactComponent };